import { FastCss, FastCssProps } from 'components/Common/FastCss';
import styled from 'styled-components';
import { JRCTypographyProps } from './JRCTypography.d';

export const lineHeightRatio = 1.5;

export const SIZES = Object.freeze({
    xs: 10,
    s: 12,
    m: 14,
    l: 16,
    xl: 18,
    xxl: 24,
    xxxl: 32,
});

export const Typography = styled.p<
    Pick<JRCTypographyProps, 'size' | 'weight' | 'color' | 'align' | 'hoverColor'> & FastCssProps
>`
    ${FastCss};
    line-height: ${lineHeightRatio}em;
    ${(props) => props.size && `font-size: ${SIZES[props.size]}px`};
    ${(props) => props.weight && `font-weight: ${props.theme.font.weight[props.weight]}`};
    ${(props) => props.color && `color: ${props.theme.color[props.color]}`};
    ${(props) => props.align && `text-align: ${props.align}`};

    &:hover {
        ${(props) =>
            props.hoverColor
                ? `
            color: ${props.theme.color[props.hoverColor]};
        `
                : ''}
    }
`;
